import axios from "axios";

export type AuthConfig = {
  userPoolId: string;
  userPoolClientId: string;
  region?: string;
};

const cacheKey = () => `authConfig:${process.env.REACT_APP_API_URL}`;

const readCache = (): AuthConfig | undefined => {
  try {
    const cached = JSON.parse(localStorage.getItem(cacheKey()) || "null");
    return cached?.userPoolId && cached?.userPoolClientId ? cached : undefined;
  } catch {
    return undefined;
  }
};

const fetchConfig = async (): Promise<AuthConfig> => {
  const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/getAuthConfig`, {});
  if (!data?.userPoolId || !data?.userPoolClientId) {
    throw new Error("The API did not return an auth configuration");
  }
  localStorage.setItem(cacheKey(), JSON.stringify(data));
  return data;
};

/**
 * Which Cognito user pool to sign in to is a property of the API environment, so it is asked of the API
 * (keyed by API URL) instead of being duplicated in per-environment frontend settings. The last answer is
 * cached so returning visitors can restore their session without waiting for this request, and is refreshed
 * in the background.
 */
export const loadAuthConfig = async (): Promise<AuthConfig> => {
  const cached = readCache();
  if (cached) {
    fetchConfig().catch(() => undefined);
    return cached;
  }
  return fetchConfig();
};
